function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1015.000000, -503.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(997.000000, 489.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "14.4677419 0.370967742 14.4677419 6.30645161 20.4032258 6.30645161"
}), /*#__PURE__*/React.createElement("polyline", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "20.4032258 9.27419355 20.4032258 6.30645161 14.4677419 0.370967742 2.59677419 0.370967742 2.59677419 9.27419355"
}), /*#__PURE__*/React.createElement("polyline", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "2.59677419 19.6612903 2.59677419 22.6290323 20.4032258 22.6290323 20.4032258 19.6612903"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,13.407897 C8,14.0781825 7.77322075,14.5961303 7.31966224,14.9617405 C6.86610374,15.3273507 6.22074789,15.5091052 5.38480097,15.5091052 L4.86127865,15.5091052 L4.86127865,17.5 L3,17.5 L3,11.5 L5.38480097,11.5 C6.25452352,11.5 6.90832328,11.6649448 7.34499397,11.9969357 C7.78166466,12.3289266 8,12.7974961 8,13.407897 Z M4.86127865,14.1884959 L5.20024125,14.1884959 C5.4800965,14.1884959 5.70205066,14.1202066 5.86731001,13.9836281 C6.03256936,13.8470496 6.1145959,13.6579408 6.1145959,13.4173525 C6.1145959,13.0118193 5.85765983,12.8101033 5.34137515,12.8101033 L4.86127865,12.8101033 L4.86127865,14.1884959 L4.86127865,14.1884959 Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,14.3723516 C15,15.3735773 14.6757426,16.1457713 14.0259901,16.6868324 C13.3762376,17.2278935 12.4641089,17.5 11.2871287,17.5 L9,17.5 L9,11.5 L11.4467822,11.5 C12.5816832,11.5 13.4579208,11.7458414 14.0742574,12.2385747 C14.6905941,12.731308 15,13.442567 15,14.3723516 Z M13.0185644,14.4301348 C13.0185644,13.8806689 12.8898515,13.4730345 12.6336634,13.2072317 C12.3774752,12.9414288 11.9888614,12.8090527 11.4665842,12.8090527 L10.9108911,12.8090527 L10.9108911,16.1699352 L11.3366337,16.1699352 C11.9170792,16.1699352 12.3415842,16.0270531 12.6126238,15.7412887 C12.8836634,15.4555244 13.0185644,15.0184731 13.0185644,14.4301348 Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  fillRule: "nonzero",
  points: "17.8014815 17.5 16 17.5 16 11.5 20 11.5 20 12.8006479 17.8014815 12.8006479 17.8014815 13.9458063 19.8293333 13.9458063 19.8293333 15.2464542 17.8014815 15.2464542"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 0.370967742,
  y: 9.27419355,
  width: 22.2580645,
  height: 10.3870968
}))))))));
var SvgIconPdf = function SvgIconPdf(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pdf.6875390e.svg";
export { ForwardRef as ReactComponent };